module.exports = __webpack_public_path__ + "static/img/scene-2.2fa824c4.png";